module.exports = __webpack_public_path__ + "aw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/aw.svg
// module id = 429
// module chunks = 0